<template>
    <div :class="['verify-phone', { 'is-error': isError }]">
        <span class="verify-phone-start">+86 {{ startPhone }}</span>
        <ux-input
            ref="refInputList"
            v-model="centerNumberList[idx]"
            v-for="(item, idx) in centerNumberList"
            :key="'centerNumber' + idx"
            @change="onChange($event, idx)"
            @keydown.delete.native="onDelete(idx)"
        ></ux-input>
        <span>{{ endPhone }}</span>
    </div>
</template>

<script>
import { rules } from '@l/rules.js';

export default {
  name: 'verifyPhone',
  model: {
    prop: 'value', // 要存在于props
    event: 'change' // 当组件的值发生改变时要emit的事件名
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    isError: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      startPhone: '', // 前三位
      endPhone: '', // 后四位
      centerNumberList: ['', '', '', ''], // 中间四位的数组
      oldCenterNumberList: ['', '', '', ''], // 旧中间四位的数组
      regPositiveInteger: rules.positiveInteger().pattern, // 包括0正整数
    };
  },
  created() {
    this.init();
  },
  mounted() {
    // 获取第一个焦点
    this.changeFocus(0);
  },
  methods: {
    init() {
      const val = this.value;
      const centerNum = [val[3], val[4], val[5], val[6]].map((item) => {
        return item === '*' ? '' : item;
      });

      this.centerNumberList = centerNum;
      this.oldCenterNumberList = centerNum;

      this.startPhone = val.slice(0, 3); // 前三位
      this.endPhone = val.slice(-4); // 后四位
    },
    // 变化
    onChange(val, idx) {
      const oldVal = this.oldCenterNumberList[idx];
      let newVal = '';
      const valLength = val.length;
      if (valLength === 1) {
        newVal = val;
      } else if (valLength > 1) {
        if (val[valLength - 1] === oldVal) {
          newVal = val[valLength - 2];
        } else {
          newVal = val[valLength - 1];
        }
      }
      if (!newVal) return;
      const reg = this.regPositiveInteger;
      this.$nextTick(() => {
        if (reg.test(newVal)) {
          // 验证通过
          this.$set(this.centerNumberList, idx, newVal);
          this.changeFocus(idx+1);
        } else {
          // 验证不通过 保留原来的
          this.$set(this.centerNumberList, idx, oldVal);
        }
      });
    },
    // 删除
    onDelete(idx) {
      if (idx === 0) return;
      if (this.centerNumberList[idx]) { // 有值就删除
        this.$set(this.centerNumberList, idx, '');
        return;
      }
      // 没值去到上一个
      const refInputList = this.$refs['refInputList'];
      this.changeFocus(idx-1);
      refInputList[idx].blur();
    },
    // 变更input焦点
    changeFocus(newIdx) {
      const refInputList = this.$refs['refInputList'];
      if (newIdx < 0 || newIdx >= refInputList.length) return;
      refInputList.forEach(item => {
        item.blur();
      });
      this.$nextTick(() => {
        const newInputEl = refInputList[newIdx].$el.querySelector('input');
        newInputEl.focus();
      });
    }
  },
  watch: {
    centerNumberList: {
      handler(newVal, oldVal) {
        this.oldCenterNumberList = JSON.parse(JSON.stringify(oldVal));
        const centerNumberList = JSON.parse(JSON.stringify(newVal));
        const centerNum = centerNumberList.map(item => item || '*').join('');
        const phone = `${this.startPhone}${centerNum}${this.endPhone}`;
        this.$emit('change', phone);
      },
      deep: true
    },
    value: {
      handler(newVal) {
        this.startPhone = newVal.slice(0, 3);
        this.endPhone = newVal.slice(-4);
      },
      deep: true
    }
  }

};

</script>

<style lang="scss" scoped>
.verify-phone {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;

    .verify-phone-start {
        margin-right: 4px;
    }

    ::v-deep .ux-input {
        width: 24px;
        margin-right: 4px;

        .el-input__inner {
            padding: 0;
            text-align: center;
        }
    }

    &.is-error {
        ::v-deep .ux-input .el-input__inner {
            border-color: $color-error;
        }
    }
}
</style>



